import React from "react";

import RedirectWithLoading from "./RedirectWithLoading";
import { useAppSelectionContext } from "../../context/App/AppSelectionContext";
import { RoutePaths } from "../config/routePaths";

export const AdministrationRedirect = () => {
  const { selectedWorkspace } = useAppSelectionContext();

  const dynamicValues = { workspaceSlug: selectedWorkspace?.slug };

  return (
    <RedirectWithLoading
      path={RoutePaths.ADMINISTRATION_GENERAL}
      dynamicValues={dynamicValues}
    />
  );
};
